if (window.innerWidth < 991) {
let SwiperTop = new Swiper('.swiper--top', {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 6000,
    loop:true,
    autoplay: {
      delay: 0.2,
    },
    mousewheel: {
      forceToAxis: true,
    },
    disableOnInteraction: true,
    slidesPerView:'auto',
    allowTouchMove: false,
});
}
